// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes slide-in-open {
  from {
    transform: translateY(50%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.wl-select-container {
  display: flex;
  justify-content: center;
}

.wl-select-form {
  width: 70%;
}

.texto-home {
  font-size: 24px;
  color: var(--text);
}

.interv-list-item {
  display: grid;
  justify-content: center;
  border-top: 1px solid var(--text);
  background-color: var(--screen-background);
  padding: 15px 10px;
}

.navbar-home{
  z-index: 11;
  position: relative;
}

.button-close{
  height: auto !important;
  transform: scale(0.8);
}

.container-buttons-inspiration {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: 25px;
  align-items: center;
  margin-top: 35px;
}

.button-revest {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 126px;
  height: 36px;
  border-radius: 100px;
  background: var(--primary-background);
  cursor: pointer;
}

.button-revest span {
  color: var(--primary-font);
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
}

/* Modal inspiração */
.box-modal-inspiration{
  visibility: hidden;
  height: 250px;
  width: 256px;
  position: absolute;
  right: 15%;
  bottom: 60px;
  background-color: var(--screen-background);
  transition: opacity 0.5s, visibility 0.5s;
  border-radius: 20px 0px 0px 0px;
  border: 1px solid var(--text);
  border-bottom: none;
}

.content-desktop{
  display: flex;
  flex-direction: column;
  gap: 28px;
  align-items: center;
}

.content h2 {
  color: var(--text);
}

.box-filter{
  /* right: 0; */
  position: relative;
  z-index: 16;
}

.main-content {
  position: relative;
  top: 30px;
  width: 100%;
  margin: 0 auto;
}

h2 {
  font-size: 16px;
  font-weight: 700;
  margin-top: 10px;
  text-align: center;
}

.mat-expansion-panel {
  box-shadow: none;
  border-radius: 8px !important;
  border: 1px solid var(--text);
  background-color: var(--screen-background);
}

.mat-expansion-panel.mat-expanded {
  box-shadow: none;
}

::ng-deep .mat-expansion-panel-content {
  overflow-y: auto !important;
}

::ng-deep .mat-expansion-indicator::after{
  color: var(--text) !important;
}

mat-accordion {
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 85%;
  z-index: 2;
}

.checkbox-filter{
  margin: 0 !important;
}

mat-panel-title {
  color: var(--text);
  font-size: 16px;
  font-weight: 700;
}

mat-chip {
  background-color: var(--screen-background);
  color: var(--text) !important;
  font-size: 12px;
  font-weight: 400;
}

::ng-deep .mat-chip-remove{
  color: var(--text) !important;
  opacity: 1 !important;
}

.container-filter-box{
  margin-top: 20px !important;
  min-height: calc(100% - 120px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.filter-chips {
  display: flex;
  flex-direction: column;
}

.filter-chips span {
  font-size: 11px;
  padding-left: 20px;
  padding-right: 20px;
  text-transform: uppercase;
  color: var(--text);
}

.filter-chips mat-chip {
  background-color: var(--screen-background);
}

.container-buttons-filter{
  padding: 0 !important;
  margin: 10px 0px 40px 0px;
}

.container-button-clear-all{
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.button-clear-all{
  font-size: 10px;
  text-transform: uppercase;
  text-decoration: underline !important;
  color: var(--text);
}

.box-filter-desktop {
  margin: 25px 0px;
  padding: 10px;
}

.box-filter-desktop-content {
  display: flex;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;
}

.box-filter-desktop-space-column {
  display: flex;
  gap: 30px;
  justify-content: center;
  margin-top: 50px;
}

.column-filter {
  display: flex;
  flex-direction: column;
  position: relative;
  max-width: 300px;
  min-width: 220px;
}

.filter-by {
  font-size: 14px;
  margin-bottom: 20px;
  margin-right: 10px;
  color: var(--text);
}

.bg-modal-inspiration {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  position: fixed;
  top: 0;
  left: 0;
  padding: 0 15px;
  cursor: default;
  z-index: 1;
  transition: opacity 0.5s, visibility 0.5s;
}

.openModalChange {
  animation: slide-up 0.3s forwards;
}

.closeModalChange {
  animation: slide-down 0.3s forwards;
}

pro-proforma-footer {
  z-index: 10;
  position: relative;
}

.filtro-mobile{
  width: calc(100% - 30px);
}

@media (max-width: 767px) {

  .container-filter-box{
    min-height: calc(100% - 20px);
  }

  .texto-home {
    font-size: 16px;
  }

  .filter-chips {
    /* margin-top: 60px; */
    margin-bottom: 20px;
  }

  .button-revest{
    width: 110px;
    height: 30px;
  }

  .button-revest span {
    font-size: 14px;
  }

  .button-close{
    height: auto !important;
    transform: scale(0.9);
  }

  h2 {
    padding: 0 40px;
    margin-top: 0px;
    font-size: 14px;
  }

  .container-buttons-inspiration{
    margin-top: 25px;
    gap: 14px;

  }

  mat-panel-title {
    font-size: 16px;
  }

  ::ng-deep .mat-chip-list{
    padding: 5px 20px !important;
  }

  .box-modal-inspiration{
    right: 16px;
    max-width: 200px;
    max-height: 210px;
  }
}

@media (min-width: 768px) {

  mat-accordion {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: -60px;
    z-index: 2;
    width: 100%;
    max-width: 250px;
  }


  ::ng-deep .filter-chips .mat-chip {
    background-color: var(--screen-background);
    color: var(--text);
    border: 1px solid;
  }

  ::ng-deep mat-panel-title {
    font-size: 14px !important;
  }

  ::ng-deep .mat-expansion-panel-header {
    height: 30px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/home/home.componente.css"],"names":[],"mappings":"AAAA;EACE;IACE,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,0CAA0C;EAC1C,yCAAyC;EACzC,+BAA+B;EAC/B,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,MAAM;EACN,OAAO;EACP,eAAe;EACf,eAAe;EACf,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,SAAS;;EAEX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;;EAEE;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;;;EAGA;IACE,0CAA0C;IAC1C,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["@keyframes slide-in-open {\n  from {\n    transform: translateY(50%);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.wl-select-container {\n  display: flex;\n  justify-content: center;\n}\n\n.wl-select-form {\n  width: 70%;\n}\n\n.texto-home {\n  font-size: 24px;\n  color: var(--text);\n}\n\n.interv-list-item {\n  display: grid;\n  justify-content: center;\n  border-top: 1px solid var(--text);\n  background-color: var(--screen-background);\n  padding: 15px 10px;\n}\n\n.navbar-home{\n  z-index: 11;\n  position: relative;\n}\n\n.button-close{\n  height: auto !important;\n  transform: scale(0.8);\n}\n\n.container-buttons-inspiration {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n  gap: 25px;\n  align-items: center;\n  margin-top: 35px;\n}\n\n.button-revest {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 126px;\n  height: 36px;\n  border-radius: 100px;\n  background: var(--primary-background);\n  cursor: pointer;\n}\n\n.button-revest span {\n  color: var(--primary-font);\n  text-align: center;\n  font-size: 16px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n/* Modal inspiração */\n.box-modal-inspiration{\n  visibility: hidden;\n  height: 250px;\n  width: 256px;\n  position: absolute;\n  right: 15%;\n  bottom: 60px;\n  background-color: var(--screen-background);\n  transition: opacity 0.5s, visibility 0.5s;\n  border-radius: 20px 0px 0px 0px;\n  border: 1px solid var(--text);\n  border-bottom: none;\n}\n\n.content-desktop{\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n  align-items: center;\n}\n\n.content h2 {\n  color: var(--text);\n}\n\n.box-filter{\n  /* right: 0; */\n  position: relative;\n  z-index: 16;\n}\n\n.main-content {\n  position: relative;\n  top: 30px;\n  width: 100%;\n  margin: 0 auto;\n}\n\nh2 {\n  font-size: 16px;\n  font-weight: 700;\n  margin-top: 10px;\n  text-align: center;\n}\n\n.mat-expansion-panel {\n  box-shadow: none;\n  border-radius: 8px !important;\n  border: 1px solid var(--text);\n  background-color: var(--screen-background);\n}\n\n.mat-expansion-panel.mat-expanded {\n  box-shadow: none;\n}\n\n::ng-deep .mat-expansion-panel-content {\n  overflow-y: auto !important;\n}\n\n::ng-deep .mat-expansion-indicator::after{\n  color: var(--text) !important;\n}\n\nmat-accordion {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  width: 85%;\n  z-index: 2;\n}\n\n.checkbox-filter{\n  margin: 0 !important;\n}\n\nmat-panel-title {\n  color: var(--text);\n  font-size: 16px;\n  font-weight: 700;\n}\n\nmat-chip {\n  background-color: var(--screen-background);\n  color: var(--text) !important;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n::ng-deep .mat-chip-remove{\n  color: var(--text) !important;\n  opacity: 1 !important;\n}\n\n.container-filter-box{\n  margin-top: 20px !important;\n  min-height: calc(100% - 120px);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.filter-chips {\n  display: flex;\n  flex-direction: column;\n}\n\n.filter-chips span {\n  font-size: 11px;\n  padding-left: 20px;\n  padding-right: 20px;\n  text-transform: uppercase;\n  color: var(--text);\n}\n\n.filter-chips mat-chip {\n  background-color: var(--screen-background);\n}\n\n.container-buttons-filter{\n  padding: 0 !important;\n  margin: 10px 0px 40px 0px;\n}\n\n.container-button-clear-all{\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n\n.button-clear-all{\n  font-size: 10px;\n  text-transform: uppercase;\n  text-decoration: underline !important;\n  color: var(--text);\n}\n\n.box-filter-desktop {\n  margin: 25px 0px;\n  padding: 10px;\n}\n\n.box-filter-desktop-content {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.box-filter-desktop-space-column {\n  display: flex;\n  gap: 30px;\n  justify-content: center;\n  margin-top: 50px;\n}\n\n.column-filter {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  max-width: 300px;\n  min-width: 220px;\n}\n\n.filter-by {\n  font-size: 14px;\n  margin-bottom: 20px;\n  margin-right: 10px;\n  color: var(--text);\n}\n\n.bg-modal-inspiration {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  position: fixed;\n  top: 0;\n  left: 0;\n  padding: 0 15px;\n  cursor: default;\n  z-index: 1;\n  transition: opacity 0.5s, visibility 0.5s;\n}\n\n.openModalChange {\n  animation: slide-up 0.3s forwards;\n}\n\n.closeModalChange {\n  animation: slide-down 0.3s forwards;\n}\n\npro-proforma-footer {\n  z-index: 10;\n  position: relative;\n}\n\n.filtro-mobile{\n  width: calc(100% - 30px);\n}\n\n@media (max-width: 767px) {\n\n  .container-filter-box{\n    min-height: calc(100% - 20px);\n  }\n\n  .texto-home {\n    font-size: 16px;\n  }\n\n  .filter-chips {\n    /* margin-top: 60px; */\n    margin-bottom: 20px;\n  }\n\n  .button-revest{\n    width: 110px;\n    height: 30px;\n  }\n\n  .button-revest span {\n    font-size: 14px;\n  }\n\n  .button-close{\n    height: auto !important;\n    transform: scale(0.9);\n  }\n\n  h2 {\n    padding: 0 40px;\n    margin-top: 0px;\n    font-size: 14px;\n  }\n\n  .container-buttons-inspiration{\n    margin-top: 25px;\n    gap: 14px;\n\n  }\n\n  mat-panel-title {\n    font-size: 16px;\n  }\n\n  ::ng-deep .mat-chip-list{\n    padding: 5px 20px !important;\n  }\n\n  .box-modal-inspiration{\n    right: 16px;\n    max-width: 200px;\n    max-height: 210px;\n  }\n}\n\n@media (min-width: 768px) {\n\n  mat-accordion {\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    top: -60px;\n    z-index: 2;\n    width: 100%;\n    max-width: 250px;\n  }\n\n\n  ::ng-deep .filter-chips .mat-chip {\n    background-color: var(--screen-background);\n    color: var(--text);\n    border: 1px solid;\n  }\n\n  ::ng-deep mat-panel-title {\n    font-size: 14px !important;\n  }\n\n  ::ng-deep .mat-expansion-panel-header {\n    height: 30px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
